import { FontAwesome5 } from "@expo/vector-icons";
import DateTimePicker from "@react-native-community/datetimepicker";
import moment from "moment";
import PropTypes from "prop-types";
import React, { useState, useEffect } from "react";
import {
    Dimensions,
    Platform,
    Text,
    TouchableOpacity,
    View,
} from "react-native";
import Modal from "react-native-modal";
import { normalize } from "../utils/normalize";
import { Button, Centered, Row } from "./all";
import { DatePickerModal } from "react-native-paper-dates";

const DateSelect = (props) => {
    const [showDatepicker, setShowDatepicker] = useState(false);
    const [prevDate, setPrevDate] = useState(new Date());
    const [selectedDate, setSelectedDate] = useState(props.initialDate || "");
    const [minDate, setMinDate] = useState();
    const [maxDate, setMaxDate] = useState();

    useEffect(() => {
        if (props.initialDate) {
            setSelectedDate(new Date(props.initialDate));
        }
    }, [props.initialDate]);

    useEffect(() => {
        // Set min date to today if beforeToday is not set
        if (!props.beforeToday) {
            setMinDate(new Date());
        }

        // Set max date if specified
        if (props.maxDate) {
            setMaxDate(props.maxDate);
        }
    }, [props.beforeToday, props.maxDate]);

    const getMinDate = () => {
        if (props.beforeToday) {
            return null;
        } else {
            return minDate;
        }
    };

    const getMaxDate = () => {
        if (props.beforeToday) {
            return new Date();
        } else {
            return maxDate;
        }
    };

    const datePickerValue = () => {
        return typeof selectedDate?.getTime === "function"
            ? selectedDate
            : new Date();
    };

    const onChangeDate = (event, selectedValue) => {
        const currentDate = selectedValue;
        setShowDatepicker(Platform.OS === "ios");

        setSelectedDate(currentDate);
        props?.onChange && props.onChange(currentDate);
    };

    return (
        <>
            <View {...props} style={{ ...props.style }}>
                <TouchableOpacity
                    onPress={() => {
                        setShowDatepicker(true);
                        setPrevDate(selectedDate);
                    }}
                >
                    <View
                        style={{
                            ...styles.calendarContainer,
                            width: props.width || Dimensions.get("window").width - 48,
                            borderColor: props.error ? "red" : "#E5E5E5",
                        }}
                    >
                        <Row centered>
                            <FontAwesome5 name="calendar-alt" size={14} color="grey" />
                            <Text
                                style={{
                                    ...styles.dateText,
                                    color: selectedDate ? "black" : "rgba(0,0,0,0.3)",
                                }}
                            >
                                {selectedDate
                                    ? moment(selectedDate).format("DD MMM YYYY")
                                    : props.placeholder || "Select Date"}
                            </Text>
                        </Row>
                    </View>
                </TouchableOpacity>
            </View>

            {Platform.OS === "ios" ? (
                <Modal
                    isVisible={showDatepicker}
                    animationIn={"fadeIn"}
                    animationOut={"fadeOut"}
                    backdropTransitionOutTiming={0}
                    hideModalContentWhileAnimating
                    backdropColor={"rgba(0,0,0,0.5)"}
                    onBackdropPress={() => {
                        onChangeDate("", prevDate);
                        setShowDatepicker(false);
                    }}
                >
                    <View
                        style={{
                            backgroundColor: "white",
                            padding: 20,
                            borderRadius: 20,
                        }}
                    >
                        <DateTimePicker
                            value={datePickerValue()}
                            mode="date"
                            onChange={onChangeDate}
                            display="inline"
                            textColor="black"
                            themeVariant="light"
                            minimumDate={getMinDate()}
                            maximumDate={getMaxDate()}
                        />
                        <Centered>
                            <Row>
                                <Button
                                    type="secondary"
                                    style={{ marginTop: 32 }}
                                    label="Cancel"
                                    onPress={() => {
                                        if (prevDate)
                                            onChangeDate("", moment(prevDate).utc().toDate());
                                        setShowDatepicker(false);
                                    }}
                                />
                                <Button
                                    type="primary"
                                    style={{ marginTop: 32 }}
                                    label="Submit"
                                    onPress={() => {
                                        if (selectedDate === "") {
                                            onChangeDate("", new Date());
                                        }
                                        setShowDatepicker(false);
                                    }}
                                />
                            </Row>
                        </Centered>
                    </View>
                </Modal>
            ) : (
                <>
                    {showDatepicker ? (
                        <DateTimePicker
                            value={datePickerValue()}
                            mode="date"
                            display={"default"}
                            onChange={onChangeDate}
                            is24Hour={false}
                            textColor="black"
                            themeVariant="light"
                            minimumDate={getMinDate()}
                            maximumDate={getMaxDate()}
                        />
                    ) : null}
                </>
            )}

            <DatePickerModal
                locale="en"
                mode="single"
                visible={Platform.OS === "web" && showDatepicker}
                onDismiss={() => {
                    setShowDatepicker(false);
                }}
                onConfirm={(params) => {
                    onChangeDate(null, params.date || new Date());
                }}
                validRange={{
                    startDate: getMinDate(),
                    endDate: getMaxDate(),
                }}
            />
        </>
    );
};

const styles = {
    calendarContainer: {
        padding: 10,
        paddingLeft: 14,
        paddingRight: 20,
        borderWidth: 1,
        borderRadius: 12,
        borderColor: "#E5E5E5",
        marginTop: 20,
    },
    dateText: {
        marginLeft: 14,
        fontSize: normalize(14),
        marginVertical: 4,
    },
};

DateSelect.propTypes = {
    initialDate: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
    placeholder: PropTypes.string,
    onChange: PropTypes.func,
    beforeToday: PropTypes.bool,
    maxDate: PropTypes.object,
    error: PropTypes.bool,
    width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    style: PropTypes.object,
};

export default DateSelect; 